import type { TOC } from '@ember/component/template-only';

interface HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipHeaderSignature {
  Args: {
    allDataSetsInSync: boolean;
    text: string;
  };
}

const HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipHeader =
  <template>
    <div
      class="benchmark-insight__data-sync-status__header text-200--medium flex items-center gap-200"
      data-test-id={{if
        @allDataSetsInSync
        "data-sync-status-header-in-sync"
        "data-sync-status-header-out-of-sync"
      }}
    >
      {{@text}}
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipHeaderSignature>;

export default HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipHeader;
